<atom-modal [width]="'600px'" (closeButtonCross)="cancel()">
  <div header>{{absenceScheduleId ? 'Melding bewerken' : 'Nieuwe melding'}}</div>
  <div body class="out-of-office-modal">
    <div class="row">

      <!--Type melding-->
      <div class="col-12 pb-3">
        <div class="modal__input">
          <div class="modal__input--label">Type melding</div>
        </div>
        <atom-radio-button
          [name]="'type'"
          [options]="radioOptionsType"
          [displayOption]="'displayOption'"
          (checkedOption)="checkType($event)"
          >
        </atom-radio-button>
      </div>

      <!--Deadline-->
      <div class="col-12 box">
        <div class="row">

          <!--Deadline-->
          <div class="col-6">
            <div class="modal__input">
              <div class="modal__input--label">
                {{
                checkedRadio_type.name === 'Daily'
                ?
                'Vanaf'
                :
                'Startdatum'
                }}
              </div>
            </div>
            <atom-date-picker
              [control]="dateFrom">
            </atom-date-picker>


          </div>

          <!--Deadline-->
          <div class="col-6">
            <div class="modal__input">
              <div class="modal__input--label d-flex align-items-center">
                <atom-checkbox
                  [color]="colors.Blue"
                  [class]="'checkbox__padding--right'"
                  [control]="dateToCheckbox"
                  >
                </atom-checkbox>
                {{
                checkedRadio_type.name === 'Daily'
                ?
                'Tot en met'
                :
                'Einddatum'
                }}

              </div>
            </div>
            <div class="position-relative">
              <atom-date-picker
                [min]="dateFrom.value"
                [disabled]="!dateToCheckbox.value"
                [control]="dateTo">
              </atom-date-picker>
              @if (!dateToCheckbox.value) {
                <div class="disabled-overlay" [ngClass]="!dateToCheckbox.value && timeCheckbox.value ? 'disabled-overlay-radius' : ''"></div>
              }
            </div>
          </div>

          <!--Herhaal-->
          @if (checkedRadio_type.name !== 'Daily') {
            <div class="col-6 pb-2">
              <div class="modal__input">
                <div class="modal__input--label">
                  Herhaal elke
                </div>
              </div>
              <atom-select
                [options]="checkedRadio_type.name === 'Weekly' ?  repeatOptions_week : repeatOptions_month"
                [displayOption]="'name'"
                [placeholder]="'Selecteer option'"
                [control]="frequency">
              </atom-select>
            </div>
          }

          <!--Herhaal - Week-->
          @if (checkedRadio_type.name === 'Weekly') {
            <div class="col-12 pb-2">
              <div class="modal__input">
                <div class="modal__input--label">
                  Afwezig op
                </div>
              </div>
              <div class="col-12 p-0 dateCheckbox dateCheckbox__container">
                @for (day of weekArray; track $index) {
                  <span class="dateCheckbox__wrapper">
                    <atom-checkbox
                      [color]="colors.Blue"
                      [(checked)]="day.checked">
                    </atom-checkbox>
                    <span class="day {{checkedRadio_type.name !== 'Weekly' ? 'day--disabled' : ''}}">{{ day.displayName }}</span>
                  </span>
                }
              </div>
            </div>
          }

          <!--Herhaal - Month-->
          @if (checkedRadio_type.name === 'Monthly') {
            <div class="col-12">
              <div class="repeat pb-1">
                <atom-radio-button
                  [control]="monthRepeat"
                  [value]="'single'"
                  >
                </atom-radio-button>
                Elke
                <atom-select [options]="monthDays"
                  [className]="'pl-1 pr-1'"
                  [placeholder]="''"
                  [width]="'80px'"
                  [control]="monthRepeatDay">
                </atom-select>
                van de maand
              </div>
              <div class="repeat">
                <atom-radio-button
                  [control]="monthRepeat"
                  [value]="'repeat'"
                  >
                </atom-radio-button>
                Elke
                <atom-select [options]="monthWeekIntervals"
                  [displayOption]="'name'"
                  [className]="'pl-1 pr-05'"
                  [placeholder]="''"
                  [width]="'80px'"
                  [control]="monthRepeatWeekInterval">
                </atom-select>
                <atom-select [options]="weekNames"
                  [displayOption]="'name'"
                  [className]="'pl-05 pr-1'"
                  [placeholder]="''"
                  [width]="'180px'"
                  [control]="monthRepeatWeekDay">
                </atom-select>
                van de maand
              </div>
            </div>
          }
        </div>
        <div class="row">
          <div class="col-6">
            <div class="modal__input--label d-flex align-items-center pt-2">
              <atom-checkbox
                [color]="colors.Blue"
                [class]="'checkbox__padding--right'"
                [control]="timeCheckbox">
              </atom-checkbox>
              Selecteer een tijd
            </div>
          </div>
          <div class="col-6 position-relative">
            @if (!dateToCheckbox.value && timeCheckbox.value) {
              <div class="disabled-overlay-white-space"></div>
            }
          </div>
        </div>
        <div class="row">
          <div class="col-6">
            @if (displayTimeSelection) {
              <div class="pt-2 d-flex justify-content-center">
                <atom-time-picker  [control]="timeFrom"></atom-time-picker>
              </div>
            }
          </div>
          <div class="col-6 position-relative">
            @if (displayTimeSelection) {
              <div class="pt-2 d-flex justify-content-center">
                <atom-time-picker  [control]="timeTo"></atom-time-picker>
              </div>
            }
            @if (!dateToCheckbox.value) {
              <div class="disabled-overlay-time"></div>
            }
          </div>
        </div>
      </div>

      <!--Doorsturen naar-->
      <div class="col-6 pb-3">
        <div class="modal__input">
          <div class="modal__input--label">
            Doorsturen naar <span>(optioneel)</span>
          </div>
        </div>
        <atom-select [options]="assigneeUsers"
          [displayOption]="'displayOption'"
          [placeholder]="'Selecteer medewerker'"
          [control]="assignee">
        </atom-select>
      </div>

      <!--Automatisch bericht-->
      <div class="col-12">
        <div class="modal__input">
          <div class="modal__input--label">
            Automatisch bericht <span>(optioneel)</span>
          </div>
        </div>
        <atom-input [type]="inputType.Textarea"
          [placeholder]="'Vul hier uw automatisch verstuurde bericht'"
          [rows]="rows" [resize]="false"
          [background]="colors.White"
          [control]="automaticReply"
          >
        </atom-input>
      </div>

    </div>
  </div>
  <div footer class="d-flex justify-content-end gap-1">

    <!-- ANNULEER / CANCEL -->
    @if (!absenceScheduleId) {
      <atom-button (onButtonClick)="cancel()"
        width="175px"
        type="secondary">
        <div text>Annuleer</div>
      </atom-button>
    }
    <!-- DELETE -->
    @if (absenceScheduleId) {
      <atom-button (onButtonClick)="deleteAbsenceSchedule()"
        width="175px"
        type="secondary">
        <div text>Verwijderen</div>
      </atom-button>
    }
    <!-- ADD -->
    @if (!absenceScheduleId) {
      <atom-button (onButtonClick)="addAbsenceSchedule()"
        [disabled]="disableAddButton()"
        width="175px"
        type="primary">
        <div text>Melding toevoegen</div>
      </atom-button>
    }
    <!-- SAVE UPDATES -->
    @if (absenceScheduleId) {
      <atom-button (onButtonClick)="updateAbsenceSchedule()"
        [disabled]="disableUpdateButton()"
        width="200px"
        type="primary">
        <div text>Opslaan</div>
      </atom-button>
    }
  </div>
</atom-modal>
